import React from "react";
import Introduction from "./components/Introduction";
import UnlockingIntelligence from "./components/UnlockingIntelligence";
import FeatureCarousel from "./components/FeatureCarousel";
import Team from "./components/Team";
import CallToAction from "./components/CallToAction";
import { featureCardData } from "./data/featureCardData";
import { staffMembers } from "./data/staffData";

const About: React.FC = () => {
  return (
    <div className="bg-gray-900 text-gray-300 flex-grow py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <Introduction />
        <UnlockingIntelligence />
        <FeatureCarousel featureCards={featureCardData} />
        <Team staffMembers={staffMembers} />
        <CallToAction />
      </div>
    </div>
  );
};

export default About;
